import { NBSP } from '../../../../../../../constants';
import { pluralDays } from '../../../../../../../utils/string';

interface IParams {
  endDate: string;
  durationInDays: number;
}

export const formatExpirationDate = (params: IParams): string => {
  const { endDate, durationInDays } = params;

  return `До${NBSP}${endDate}${NBSP}(${pluralDays(durationInDays)})`;
};
